import Textfield from "../Input/Textfield";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Spinner from "../Spinner/Spinner";
import useBranchId from "@/shared/hooks/useBranchId";
import { useIsFetching } from "@tanstack/react-query";
import usePosOrderUser from "@/shared/atoms/usePosOrderUser";

const City = () => {
  const { t } = useTranslation();
  const { register, getValues } = useFormContext();
  const branchId = useBranchId();
  const [orderUser] = usePosOrderUser();
  const values = getValues();
  const { zip_code, house_number } = values.order_user ?? {};

  const isFetching = useIsFetching({
    queryKey: ["zipcode", branchId, zip_code, house_number],
  });

  return (
    <Textfield
      ref={register({})}
      defaultValue={orderUser?.city}
      label={t("posOrders.city")}
      name="order_user.city"
      inputRightAddon={isFetching ? <Spinner size="0.18rem" /> : null}
    />
  );
};

export default City;
